<script setup lang="ts">
import type { OperationModelType } from "~/core/models/OperationModelType.enum";
import { getOperationModelTypeLabel } from "~/modules/campaign/utils/getOperationModelTypeLabel";

defineProps<{
  operationTypes?: OperationModelType[];
}>();

const { t, te } = useI18n();
</script>

<template>
  <span v-if="operationTypes && operationTypes?.length > 1">
    {{ t("campaign.operationModelType.composite") }}
  </span>
  <span v-else-if="operationTypes?.length === 1">
    {{ getOperationModelTypeLabel(operationTypes[0], te, t) }}
  </span>
</template>
